/*
 * Live free shipping message for the Top Information Bar (sections/top-infobar.liquid).
 * Loaded only when a block has "Show live free shipping progress" ticked.
 * Reads /cart.js on load and on cart changes, then rewrites each .fsbar-live span.
 */
(function () {
  'use strict';

  var timer = null;

  function nodes() {
    return document.querySelectorAll('.fsbar-live');
  }

  function money(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function render(cart) {
    nodes().forEach(function (el) {
      var d = el.dataset;
      // Threshold is in GBP; for any other cart currency keep the block's default text.
      if (!cart || cart.item_count === 0 || cart.currency !== 'GBP') {
        el.innerHTML = d.fsDefault || '';
        return;
      }
      var threshold = Math.round(parseFloat(d.fsThreshold || '0') * 100);
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        el.innerHTML = (d.fsUnder || '').replace('[amount]', '<b>' + money(remaining) + '</b>');
      } else {
        el.innerHTML = d.fsOver || '';
      }
    });
  }

  function refresh() {
    if (!nodes().length) return;
    var base = (window.routes && routes.cart_url) ? routes.cart_url : '/cart';
    fetch(base + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { if (cart) render(cart); })
      .catch(function () { /* leave current text in place */ });
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!nodes().length) return;
    refresh();

    // Theme cart bus (assets/vendor.js), published by assets/cart.js on add and quantity change.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, queue);
    }

    // Rebuy Smart Cart DOM events, confirmed in Rebuy's developer docs:
    // https://developers.rebuyengine.com/reference/cart-event-listeners
    ['rebuy:cart.ready', 'rebuy:cart.add', 'rebuy:cart.change'].forEach(function (name) {
      document.addEventListener(name, queue);
    });
  });
})();
